import { SelectButtonItem } from 'src/components/choose-button/choose-button';
import { i18n } from 'src/i18n';
import { ServiceType } from 'src/model/service-type';
import {
  blackWifiImageProps,
  cellTowerImageProps,
  gamingImageProps,
  phoneImageProps,
  tvImageProps,
} from 'src/resources/images';

class ServiceTypeMapper {
  public static toSelectButtonItem = (serviceType: string): SelectButtonItem => {
    switch (serviceType) {
      case ServiceType.TV:
        return {
          text: i18n.page.chooseServiceLocation.tv,
          icon: tvImageProps,
        };
      case ServiceType.INTERNET:
        return {
          text: i18n.page.chooseServiceLocation.wifi,
          icon: blackWifiImageProps,
        };
      case ServiceType.VOIP:
        return {
          text: i18n.page.chooseServiceLocation.phone,
          icon: phoneImageProps,
        };
      case ServiceType.XBOX_ALL_ACCESS:
        return {
          text: i18n.page.chooseServiceLocation.gaming,
          icon: gamingImageProps,
        };
      case ServiceType.FWA:
        return {
          text: i18n.page.chooseServiceLocation.fixedWirelessAccess,
          icon: cellTowerImageProps,
        };
      default:
        return {
          text: serviceType,
          icon: tvImageProps,
        };
    }
  };
}

export { ServiceTypeMapper };
